import { inject, Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { httpOptions } from '@core/services/config/app-config.service';

import { environment } from 'src/environments/environment';
/* import { Globals } from 'src/app/globals';
import { Nazione } from '../models/nazione.interface'; */
import { AppConfigService } from '@core/services/config/app-config.service';


@Injectable({
    providedIn: 'root',
})
export class SettingService {
    appConfig = inject(AppConfigService);

    lang: string;
    domain: string;

    constructor(private http: HttpClient) {
        this.lang = this.appConfig.lang();
        this.domain = this.appConfig.site_domain;
    }

    getSetting(setting: string, lang: string = ''): Observable<any> {
        lang = lang || this.lang;
        return this.http.get(this.appConfig.apiUrl() + '/getSetting?setting=' + setting + '&lang=' + this.lang, httpOptions);
    }

    subscribeNewsletter(payload: any) {
        return this.http.post(
            this.appConfig.apiUrl() + '/newsletter/subscribe',
            payload,
            httpOptions
        );
    }
}
